// import React, { useState } from "react";
// import "./SearchBar.css";

// const SearchBar = () => {
//   // State
//   const [location, setLocation] = useState("Karachi");
//   const [showLocationDropdown, setShowLocationDropdown] = useState(false);

//   const [dateFrom, setDateFrom] = useState("2025-09-14");
//   const [dateTo, setDateTo] = useState("2025-09-19");

//   const [showGuests, setShowGuests] = useState(false);
//   const [adults, setAdults] = useState(2);
//   const [children, setChildren] = useState(0);
//   const [rooms, setRooms] = useState(1);

//   // Functions for +/- buttons
//   const updateValue = (setter, value, min = 0) => {
//     if (value >= min) setter(value);
//   };

//   return (
//     <div className="searchbar-wrapper">
//       <div className="searchbar">
//         {/* Location */}
//         <div className="search-item" onClick={() => setShowLocationDropdown(!showLocationDropdown)}>
//           <span className="icon">🏨</span>
//           <input
//             type="text"
//             value={location}
//             onChange={(e) => setLocation(e.target.value)}
//             placeholder="Where are you going?"
//           />
//           {showLocationDropdown && (
//             <div className="dropdown-box">
//               <p onClick={() => setLocation("Karachi")}>Karachi</p>
//               <p onClick={() => setLocation("Lahore")}>Lahore</p>
//               <p onClick={() => setLocation("Islamabad")}>Islamabad</p>
//             </div>
//           )}
//         </div>

//         {/* Date Picker */}
//         <div className="search-item">
//           <span className="icon">📅</span>
//           <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
//           <span style={{ margin: "0 6px" }}>—</span>
//           <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
//         </div>

//         {/* Guests & Rooms */}
//         <div
//           className="search-item"
//           onClick={() => setShowGuests(!showGuests)}
//         >
//           <span className="icon">👤</span>
//           <span className="text">
//             {adults} adults · {children} children · {rooms} room
//           </span>
//           <span className="dropdown">▼</span>

//           {showGuests && (
//             <div className="dropdown-box">
//               <div className="guest-row">
//                 <span>Adults</span>
//                 <div className="counter">
//                   <button onClick={() => updateValue(setAdults, adults - 1, 1)}>-</button>
//                   <span>{adults}</span>
//                   <button onClick={() => updateValue(setAdults, adults + 1)}>+</button>
//                 </div>
//               </div>
//               <div className="guest-row">
//                 <span>Children</span>
//                 <div className="counter">
//                   <button onClick={() => updateValue(setChildren, children - 1, 0)}>-</button>
//                   <span>{children}</span>
//                   <button onClick={() => updateValue(setChildren, children + 1)}>+</button>
//                 </div>
//               </div>
//               <div className="guest-row">
//                 <span>Rooms</span>
//                 <div className="counter">
//                   <button onClick={() => updateValue(setRooms, rooms - 1, 1)}>-</button>
//                   <span>{rooms}</span>
//                   <button onClick={() => updateValue(setRooms, rooms + 1)}>+</button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>

//         {/* Search Button */}
//         <button className="search-btn">Search</button>
//       </div>
//     </div>
//   );
// };

// export default SearchBar;

























import React, { useState, useEffect } from "react";
import "./SearchBar.css";
import { toast } from "react-toastify";

const SearchBar = ({ onSearch, defaultCity }) => {
  const [formData, setFormData] = useState({
    destination: "",
    checkIn: "",
    checkOut: "",
    adults: 0,
    children: 0,
    rooms: 0,
    childrenAgesNeeded: [],
  });

  // 🔹 Default dates: today & tomorrow
  useEffect(() => {
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    const formatDate = (date) => date.toISOString().split("T")[0];

    const stored = JSON.parse(localStorage.getItem("BookingDate"));
    if (stored) {
      setFormData(stored);
    } else {
      setFormData({
        destination: defaultCity || "",
        checkIn: formatDate(today),
        checkOut: formatDate(tomorrow),
        adults: 0,
        children: 0,
        rooms: 0,
        childrenAgesNeeded: [],
      });
    }
  }, [defaultCity]);

  // 🔹 handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // 🔹 form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.checkIn || !formData.checkOut) {
      toast.success("Please select check-in and check-out dates.");
      return;
    }

    if (formData.adults <= 0 || formData.rooms <= 0) {
      toast.success("Please add at least one room and one adult.");
      return;
    }

    localStorage.setItem("BookingDate", JSON.stringify(formData));

    toast.success("Booking data saved ✅");
  };

  // 🔹 handle guest count popup toggle
  const [showGuestPopup, setShowGuestPopup] = useState(false);

  const updateGuestCount = (type, key) => {
    setFormData((prev) => {
      let value = prev[key];
      if (type === "inc") value++;
      else if (type === "dec" && value > 0) value--;

      // if children change, update age array length
      let childrenAgesNeeded = [...prev.childrenAgesNeeded];
      if (key === "children") {
        if (value > childrenAgesNeeded.length) {
          childrenAgesNeeded.push("");
        } else {
          childrenAgesNeeded = childrenAgesNeeded.slice(0, value);
        }
      }

      return { ...prev, [key]: value, childrenAgesNeeded };
    });
  };

  const handleChildAgeChange = (index, value) => {
    setFormData((prev) => {
      const updated = [...prev.childrenAgesNeeded];
      updated[index] = value;
      return { ...prev, childrenAgesNeeded: updated };
    });
  };

  return (
    <div className="search-section" style={{background:"#f0583a"}}>
      <form className="search-bar" onSubmit={handleSubmit} style={{background:"#f0583a"}}>
        {/* Location */}
        <div className="search-field">
          <label style={{    color: "white"}}>Location</label>
          <input
            type="text"
            className="date-input"
            name="destination"
            value={formData.destination}
            onChange={handleChange}
            placeholder="Enter city or area"
          />
        </div>

        {/* Check-in */}
        <div className="search-field">
          <label style={{    color: "white"}}>Check-in</label>
          <input
            type="date"
            className="date-input"
            name="checkIn"
            value={formData.checkIn}
            onChange={handleChange}
          />
        </div>

        {/* Check-out */}
        <div className="search-field">
          <label style={{    color: "white"}}>Check-out</label>
          <input
            type="date"
            className="date-input"
            name="checkOut"
            value={formData.checkOut}
            onChange={handleChange}
          />
        </div>

        {/* Guests */}
        <div className="search-field" style={{minWidth:"240px"}}>
          <label style={{    color: "white"}}>Guests</label>
          <div
            className="guest-popup-trigger"
            onClick={() => setShowGuestPopup(!showGuestPopup)}
          >
            {formData.adults} adults · {formData.children} children · {formData.rooms} room
          </div>

          {showGuestPopup && (
            <div className="guest-popup">
              <div className="guest-row">
                <span>Adults</span>
                <div className="counter">
                  <button type="button" onClick={() => updateGuestCount("dec", "adults")}>-</button>
                  <span>{formData.adults}</span>
                  <button type="button" onClick={() => updateGuestCount("inc", "adults")}>+</button>
                </div>
              </div>

              <div className="guest-row">
                <span>Children</span>
                <div className="counter">
                  <button type="button" onClick={() => updateGuestCount("dec", "children")}>-</button>
                  <span>{formData.children}</span>
                  <button type="button" onClick={() => updateGuestCount("inc", "children")}>+</button>
                </div>
              </div>

              {formData.children > 0 && (
                <div className="children-ages">
                  {formData.childrenAgesNeeded.map((age, index) => (
                    <select
                      key={index}
                      value={age}
                      onChange={(e) => handleChildAgeChange(index, e.target.value)}
                    >
                      <option value="">Select age</option>
                      {Array.from({ length: 18 }).map((_, i) => (
                        <option key={i} value={`${i} years old`}>
                          {i} year{i !== 1 && "s"} old
                        </option>
                      ))}
                    </select>
                  ))}
                </div>
              )}

              <div className="guest-row">
                <span>Rooms</span>
                <div className="counter">
                  <button type="button" onClick={() => updateGuestCount("dec", "rooms")}>-</button>
                  <span>{formData.rooms}</span>
                  <button type="button" onClick={() => updateGuestCount("inc", "rooms")}>+</button>
                </div>
              </div>

              <button
                type="button"
                className="done-btn"
                onClick={() => setShowGuestPopup(false)}
              >
                Done
              </button>
            </div>
          )}
        </div>

        {/* Submit */}
        <button type="submit" className="search-btn">
          Search
        </button>
      </form>
    </div>
  );
};

export default SearchBar;






























// import React, { useState, useEffect } from "react";
// import "./SearchBar.css";

// const SearchBar = ({ onSearch, defaultCity }) => {
//   const [formData, setFormData] = useState({
//     destination: "",
//     checkIn: "",
//     checkOut: "",
//     adults: 1,
//     children: 0,
//     rooms: 1,
//     childrenAgesNeeded: [],
//   });

//   const [showGuestPopup, setShowGuestPopup] = useState(false);

//   // 🔹 Set default dates on mount
//   useEffect(() => {
//     const today = new Date();
//     const tomorrow = new Date();
//     tomorrow.setDate(today.getDate() + 1);

//     const formatDate = (date) => {
//       const yyyy = date.getFullYear();
//       const mm = String(date.getMonth() + 1).padStart(2, "0");
//       const dd = String(date.getDate()).padStart(2, "0");
//       return `${yyyy}-${mm}-${dd}`;
//     };

//     const stored = JSON.parse(localStorage.getItem("BookingDate"));
//     if (stored) {
//       setFormData(stored);
//     } else {
//       setFormData({
//         destination: defaultCity || "",
//         checkIn: formatDate(today),
//         checkOut: formatDate(tomorrow),
//         adults: 1,
//         children: 0,
//         rooms: 1,
//         childrenAgesNeeded: [],
//       });
//     }
//   }, [defaultCity]);

//   // 🔹 Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   // 🔹 Update guest counts
//   const updateGuestCount = (type, key) => {
//     setFormData((prev) => {
//       let value = prev[key];
//       if (type === "inc") value++;
//       else if (type === "dec" && value > 0) value--;

//       // If children change, update age array length
//       let childrenAgesNeeded = [...prev.childrenAgesNeeded];
//       if (key === "children") {
//         if (value > childrenAgesNeeded.length) {
//           childrenAgesNeeded.push("");
//         } else {
//           childrenAgesNeeded = childrenAgesNeeded.slice(0, value);
//         }
//       }

//       return { ...prev, [key]: value, childrenAgesNeeded };
//     });
//   };

//   const handleChildAgeChange = (index, value) => {
//     setFormData((prev) => {
//       const updated = [...prev.childrenAgesNeeded];
//       updated[index] = value;
//       return { ...prev, childrenAgesNeeded: updated };
//     });
//   };

//   // 🔹 Submit handler
//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.checkIn || !formData.checkOut) {
//       toast.success("Please select check-in and check-out dates.");
//       return;
//     }

//     if (formData.adults <= 0 || formData.rooms <= 0) {
//       toast.success("Please add at least one room and one adult.");
//       return;
//     }

//     localStorage.setItem("BookingDate", JSON.stringify(formData));
//     if (onSearch) onSearch(formData);
//     toast.success("Booking data saved ✅");
//   };

//   return (
//     <div className="search-section" style={{ background: "#f0583a" }}>
//       <form
//         className="search-bar"
//         onSubmit={handleSubmit}
//         style={{ background: "#f0583a" }}
//       >
//         {/* Location */}
//         <div className="search-field">
//           <label style={{ color: "white" }}>Location</label>
//           <input
//             type="text"
//             className="date-input"
//             name="destination"
//             value={formData.destination}
//             onChange={handleChange}
//             placeholder="Enter city or area"
//           />
//         </div>

//         {/* Check-in */}
//         <div className="search-field">
//           <label style={{ color: "white" }}>Check-in</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkIn"
//             value={formData.checkIn}
//             onChange={handleChange}
//             min={formData.checkIn}
//           />
//         </div>

//         {/* Check-out */}
//         <div className="search-field">
//           <label style={{ color: "white" }}>Check-out</label>
//           <input
//             type="date"
//             className="date-input"
//             name="checkOut"
//             value={formData.checkOut}
//             onChange={handleChange}
//             min={formData.checkIn}
//           />
//         </div>

//         {/* Guests */}
//         <div className="search-field" style={{ minWidth: "240px" }}>
//           <label style={{ color: "white" }}>Guests</label>
//           <div
//             className="guest-popup-trigger"
//             onClick={() => setShowGuestPopup(!showGuestPopup)}
//           >
//             {formData.adults} adults · {formData.children} children ·{" "}
//             {formData.rooms} room{formData.rooms > 1 ? "s" : ""}
//           </div>

//           {showGuestPopup && (
//             <div className="guest-popup">
//               <div className="guest-row">
//                 <span>Adults</span>
//                 <div className="counter">
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("dec", "adults")}
//                   >
//                     -
//                   </button>
//                   <span>{formData.adults}</span>
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("inc", "adults")}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>

//               <div className="guest-row">
//                 <span>Children</span>
//                 <div className="counter">
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("dec", "children")}
//                   >
//                     -
//                   </button>
//                   <span>{formData.children}</span>
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("inc", "children")}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>

//               {formData.children > 0 && (
//                 <div className="children-ages">
//                   {formData.childrenAgesNeeded.map((age, index) => (
//                     <select
//                       key={index}
//                       value={age}
//                       onChange={(e) =>
//                         handleChildAgeChange(index, e.target.value)
//                       }
//                     >
//                       <option value="">Select age</option>
//                       {Array.from({ length: 18 }).map((_, i) => (
//                         <option key={i} value={`${i} years old`}>
//                           {i} year{i !== 1 && "s"} old
//                         </option>
//                       ))}
//                     </select>
//                   ))}
//                 </div>
//               )}

//               <div className="guest-row">
//                 <span>Rooms</span>
//                 <div className="counter">
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("dec", "rooms")}
//                   >
//                     -
//                   </button>
//                   <span>{formData.rooms}</span>
//                   <button
//                     type="button"
//                     onClick={() => updateGuestCount("inc", "rooms")}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>

//               <button
//                 type="button"
//                 className="done-btn"
//                 onClick={() => setShowGuestPopup(false)}
//               >
//                 Done
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Submit */}
//         <button type="submit" className="search-btn">
//           Search
//         </button>
//       </form>
//     </div>
//   );
// };

// export default SearchBar;
